"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfirm = void 0;
const react_1 = __importDefault(require("react"));
const default_confirmation_1 = require("./confirmation-messages/default-confirmation");
function useConfirm(onConfirm, onDecline) {
    const [defer, setDefer] = react_1.default.useState(undefined);
    const handler = react_1.default.useCallback((...args) => __awaiter(this, void 0, void 0, function* () {
        let isConfirmed;
        try {
            isConfirmed = yield new Promise((resolve, reject) => {
                setDefer({
                    confirm: () => resolve(true),
                    decline: () => resolve(false),
                    cancel: reject,
                });
            });
        }
        catch (_a) {
            return;
        }
        finally {
            setDefer(undefined);
        }
        if (isConfirmed) {
            onConfirm(...args);
        }
        else if (onDecline) {
            onDecline(...args);
        }
    }), [onConfirm, onDecline]);
    const Confirm = react_1.default.useMemo(() => (_a) => {
        var { when = true, confirmation: Confirmation = default_confirmation_1.DefaultConfirmation } = _a, props = __rest(_a, ["when", "confirmation"]);
        if (!defer) {
            return null;
        }
        if (!when) {
            defer.confirm();
            return null;
        }
        return (react_1.default.createElement(Confirmation, Object.assign({}, props, { onConfirm: defer.confirm, onDecline: defer.decline, onCancel: defer.cancel })));
    }, [defer]);
    return [Confirm, handler];
}
exports.useConfirm = useConfirm;
//# sourceMappingURL=use-confirm.js.map